import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { NodeSection } from "../props/node/constants";
/**
 * По всем наборам параметров собираем информацию о положении узлов - NodeParentInfo
 */
export var CollectParentGroupsVisitor = {
  NodeTree: function NodeTree(path, state) {
    state.children = {};
    state.parents = {};
  },
  Node: {
    enter: function enter(path, state) {
      state.currentParams = {};
      state.currentParams.nodeId = path.params.nodeId;
    },
    enterChild: function enterChild(path) {
      if (path.params.section !== NodeSection.CHILDREN) this.skip();
    }
  },
  AdaptiveDecorator: {
    enterChild: function enterChild(path, state) {
      state.currentParams.maxSize = path.params.maxSize;
      state.currentParams.minSize = path.params.minSize;
    }
  },
  FieldsDecorator: {
    enterChild: function enterChild(path, state) {
      state.currentParams.fieldId = path.params.fieldId;
    }
  },
  ListOfIdentifiers: function ListOfIdentifiers(path, state) {
    path.node.value.forEach(function (nodeId, index, array) {
      var _state$parents, _state$children, _state$currentParams$;
      state.currentParams.beforeId = array[index + 1];
      (_state$parents = state.parents)[nodeId] || (_state$parents[nodeId] = []);
      state.parents[nodeId].push(_objectSpread({}, state.currentParams));
      (_state$children = state.children)[_state$currentParams$ = state.currentParams.nodeId] || (_state$children[_state$currentParams$] = []);
      state.children[state.currentParams.nodeId].push(_objectSpread(_objectSpread({}, state.currentParams), {}, {
        nodeId: nodeId
      }));
    });
  }
};